import React from 'react'
import PropTypes from 'prop-types'

function JobDescription({ title, user = '', description }) {
  return (
    <div className="job-description">
      <div className="job-description__title">{title}</div>
      <div className="job-description__desc">
        {user
          && <span className="job-description__user">{user}: </span>
        }
        {description}
      </div>
    </div>
  )
}

JobDescription.propTypes = {
  title: PropTypes.string.isRequired,
  user: PropTypes.string,
  description: PropTypes.string.isRequired,
}

export default JobDescription
